import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getDataForTaskRequestApprovalAsync, resetSelectedRecordObjectInState, setDateRangeValue, updateTaskIdForApproval } from '../../taskrequesthours/taskRequestHoursSlice';
import fetchAPI from "../../../common/fetchAPI";
import Select, { StylesConfig } from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { DateRangePicker } from 'rsuite';
import { format } from 'date-fns';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource, dateFormatByAccountCultureForFilters } from '../../../common/timeLiveFunction';

const TaskRequestApprovalFilter = (props: any) => {
    const { modelRef, t } = props;
    const { startDate, endDate } = useAppSelector((state) => state.taskRequestHours);
    const { maxMenuHeight, sessionAccountEmployeeId, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    const [isChecked, setIsChecked] = useState(false);
    const [selectedOptionTask, setSelectedOptionTask] = useState<{ [key: string]: any } | null>(null);
    const [TaskArray, SetTaskArray] = useState<any | ''>([]);
    const currentDate = new Date();
    const [SelectedStartDate, setSelectedStartDate] = useState(currentDate);
    const [SelectedEndDate, setSelectedEndDate] = useState(currentDate);
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');

    const getTasks = async () => {
        const response = await fetchAPI('api/Tasks/GetDataForTaskRequestDropDown', "GET", "", true);
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.AccountProjectTaskId;
            item.label = item.TaskName;
            delete item.AccountProjectTaskId;
            delete item.AccountProjectTaskId;
        });
        SetTaskArray(json);
    }

    useEffect(() => {
        getTasks();
    }, []);

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    const handleSubmit = () => {
        const AccountProjectTaskId = selectedOptionTask === null || selectedOptionTask === undefined ? 0 : selectedOptionTask?.value;
        const StartDate = moment(startDate).format(dateInsertionFormat);
        // const EndDate = moment(endDate).format('MM-DD-YYYY');
        const EndDate = moment(endDate).format(dateInsertionFormat);
        dispatch(getDataForTaskRequestApprovalAsync({ StartDate, EndDate, AccountProjectTaskId }));
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }

    const handleChangeTasks = (selectedOption: any) => {
        updateTaskIdForApproval(selectedOption?.value)
        setSelectedOptionTask(selectedOption);
    }

    const handleDateRangeChange = (value: any) => {
        // setSelectedStartDate(value[0]);
        // setSelectedEndDate(value[1]);
        // dispatch(setDateRangeValue({ startDate: value[0].toISOString(), endDate: value[1].toISOString() }))
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        // setSelectedStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
        // setSelectedEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
        // dispatch(setDateRangeValue({ startDate: dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()), endDate: dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()) }));
        setSelectedStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
        setSelectedEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
        dispatch(setDateRangeValue({ startDate: format(value[0], "yyyy-MM-dd"), endDate: format(value[1], "yyyy-MM-dd") }));
    }

    const handleCloseOnClickEvent = () => {
        // setSelectedOptionTask(null);
        setSelectedStartDate(new Date());
        setSelectedEndDate(new Date());
        dispatch(resetSelectedRecordObjectInState());
    }

    return (
        <>
            <div className='card-body' style={{ overflowY: 'auto' }}>
                <div className='col-md-12'>
                    <div className='col-md-12'>
                        <label className="fs-7 fw-normal mb-2">
                            {/* {t('Date Range')} */}
                            {getValueFromResource('Date Range',dispatch, t)}
                            </label>
                        <div>
                            <DateRangePicker
                                onChange={handleDateRangeChange}
                                value={[SelectedStartDate, SelectedEndDate]}
                                // placeholder='Please Select Date Range'
                                placeholder={displayedRange}
                                character={' - '}
                                cleanable={false}
                                placement="bottomEnd"
                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                            ></DateRangePicker>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2 mt-6">
                            {/* {t('Task Name')} */}
                            {getValueFromResource('Task Name',dispatch, t)}
                            </label>
                        <Select
                            value={selectedOptionTask}
                            id="AccountProjectTaskId"
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="AccountProjectTaskId"
                            onChange={handleChangeTasks}
                            options={TaskArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    <button
                        ref={closeButtonRef}
                        type="button"
                      className="btn btn-secondary btn-sm me-2 fs-7"
                        id="kt_OffCanvas"
                        onClick={handleCloseOnClickEvent}
                    >
                        {/* {t('Cancel')} */}
                        {getValueFromResource('Reset Filters',dispatch, t)}
                    </button>
                    <button
                        type="button"
                        data-kt-element='send'
                        className="btn btn-primary btn-sm fs-7"
                        onClick={() => handleSubmit()}
                    >
                        {/* {t('Apply Filters')} */}
                        <i className="bi bi-filter fs-5 me-1"></i>  
                        {getValueFromResource('Apply Filters',dispatch, t)}
                    </button>
                </div>
            </div>
        </>
    )
}

export default TaskRequestApprovalFilter